import React, { useState } from 'react';
import { Icons } from '../Icons';
import { APIService } from '../../services/api';

const ResetPasswordPage = ({ token, onSuccess }) => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (password.length < 8) {
            setError('Heslo musí mít alespoň 8 znaků');
            return;
        }
        
        if (password !== confirmPassword) {
            setError('Hesla se neshodují');
            return;
        }
        
        setLoading(true);
        setError(null);
        
        try {
            const result = await APIService.resetPassword(token, password);
            if (result.success) {
                setSuccess(true);
                setTimeout(() => {
                    onSuccess && onSuccess();
                }, 2000);
            } else {
                setError(result.message || 'Nepodařilo se obnovit heslo');
            }
        } catch (err) {
            setError(err.message || 'Chyba při obnově hesla');
        } finally {
            setLoading(false);
        }
    };
    
    if (success) {
        return (
            <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
                <div className="glass-card p-8 w-full max-w-md text-center animate-slide-in">
                    <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-green-500/20 flex items-center justify-center">
                        <Icons.Check size={32} className="text-green-400" />
                    </div>
                    <h1 className="text-2xl font-bold text-white mb-2">Heslo bylo změněno</h1>
                    <p className="text-slate-400 mb-6">
                        Vaše heslo bylo úspěšně aktualizováno. Nyní budete přesměrováni na přihlášení.
                    </p>
                    <div className="w-8 h-8 border-2 border-cyan-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
                </div>
            </div>
        );
    }
    
    return (
        <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
            <div className="glass-card p-8 w-full max-w-md animate-slide-in">
                <div className="text-center mb-8">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-br from-cyan-500/20 to-purple-500/20 flex items-center justify-center">
                        <Icons.Lock size={28} className="text-cyan-400" />
                    </div>
                    <h1 className="text-2xl font-bold text-white mb-2">Obnovení hesla</h1>
                    <p className="text-slate-400">Zadejte nové heslo pro váš účet</p>
                </div>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-slate-300 mb-2">
                            Nové heslo
                        </label>
                        <div className="relative">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Minimálně 8 znaků"
                                className="w-full px-4 py-3 bg-slate-800 border border-slate-700 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 pr-12"
                                required
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white"
                            >
                                {showPassword ? <Icons.Eye size={20} /> : <Icons.Eye size={20} />}
                            </button>
                        </div>
                    </div>
                    
                    <div>
                        <label className="block text-sm font-medium text-slate-300 mb-2">
                            Potvrdit heslo
                        </label>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Zopakujte heslo"
                            className="w-full px-4 py-3 bg-slate-800 border border-slate-700 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500"
                            required
                        />
                    </div>
                    
                    {error && (
                        <div className="p-3 bg-red-500/10 border border-red-500/30 rounded-lg text-red-400 text-sm flex items-center gap-2">
                            <Icons.Warning size={16} />
                            {error}
                        </div>
                    )}
                    
                    <button
                        type="submit"
                        disabled={loading}
                        className={`w-full px-4 py-3 rounded-lg font-semibold transition-all ${
                            loading
                                ? 'bg-slate-700 text-slate-400 cursor-not-allowed'
                                : 'bg-gradient-to-r from-cyan-500 to-purple-600 hover:from-cyan-600 hover:to-purple-700 text-white'
                        }`}
                    >
                        {loading ? (
                            <span className="flex items-center justify-center gap-2">
                                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                Ukládám...
                            </span>
                        ) : (
                            'Změnit heslo'
                        )}
                    </button>
                </form>
                
                <div className="mt-6 text-center">
                    <a href="/" className="text-slate-400 hover:text-cyan-400 text-sm transition-colors">
                        Zpět na hlavní stránku
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
